/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class EmployeeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增或更改员工信息
     * @param employeeSubmitDTO employeeSubmitDTO
     * @return OK
     */
    createOrUpdateEmployee(employeeSubmitDTO: EmployeeSubmitDTO): Promise<Employee> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeSubmitDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateEmployee(_response);
        });
    }

    protected processCreateOrUpdateEmployee(response: AxiosResponse): Promise<Employee> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Employee.fromJS(resultData200) : new Employee();
            return result200;
        }
        return Promise.resolve<Employee>(<any>null);
    }

    /**
     * 批量删除员工
     * @param ids ids
     * @return OK
     */
    deleteEmployee(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteEmployee(_response);
        });
    }

    protected processDeleteEmployee(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据职权域id查找员工
     * @param deptIdList deptIdList
     * @return OK
     */
    employeeDeptList(deptIdList: string[]): Promise<EmployeeInfoBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/dept?";
        if (deptIdList === undefined || deptIdList === null)
            throw new Error("The parameter 'deptIdList' must be defined and cannot be null.");
        else
            deptIdList && deptIdList.forEach(item => { url_ += "deptIdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEmployeeDeptList(_response);
        });
    }

    protected processEmployeeDeptList(response: AxiosResponse): Promise<EmployeeInfoBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeInfoBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<EmployeeInfoBO[]>(<any>null);
    }

    /**
     * 根据code获取员工详情
     * @param code code
     * @return OK
     */
    getEmployeeDetail(code: string): Promise<EmployeeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/getEmployeeDetail?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEmployeeDetail(_response);
        });
    }

    protected processGetEmployeeDetail(response: AxiosResponse): Promise<EmployeeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? EmployeeVO.fromJS(resultData200) : new EmployeeVO();
            return result200;
        }
        return Promise.resolve<EmployeeVO>(<any>null);
    }

    /**
     * getHmiEmployeeList
     * @param employeeSearchDTO employeeSearchDTO
     * @return OK
     */
    getHmiEmployeeList(employeeSearchDTO: EmployeeSearchDTO): Promise<EmployeeInfoBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/hmi-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetHmiEmployeeList(_response);
        });
    }

    protected processGetHmiEmployeeList(response: AxiosResponse): Promise<EmployeeInfoBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeInfoBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<EmployeeInfoBO[]>(<any>null);
    }

    /**
     * getEmployeeList
     * @param employeeSearchDTO employeeSearchDTO
     * @return OK
     */
    getEmployeeList(employeeSearchDTO: EmployeeSearchDTO): Promise<EmployeeInfoBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEmployeeList(_response);
        });
    }

    protected processGetEmployeeList(response: AxiosResponse): Promise<EmployeeInfoBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeInfoBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<EmployeeInfoBO[]>(<any>null);
    }

    /**
     * 员工信息列表
     * @param current (optional) 当前页
     * @param employeeSearchDTO employeeSearchDTO
     * @param keyWords (optional) keyWords
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageEmployees(current: number | null | undefined, employeeSearchDTO: EmployeeSearchDTO, keyWords: string | null | undefined, size: number | null | undefined): Promise<IPageOfEmployeeInfoBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageEmployees(_response);
        });
    }

    protected processGetPageEmployees(response: AxiosResponse): Promise<IPageOfEmployeeInfoBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfEmployeeInfoBO.fromJS(resultData200) : new IPageOfEmployeeInfoBO();
            return result200;
        }
        return Promise.resolve<IPageOfEmployeeInfoBO>(<any>null);
    }

    /**
     * 重置员工
     * @param id id
     * @return OK
     */
    resetEmployee(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/reset-employee?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetEmployee(_response);
        });
    }

    protected processResetEmployee(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 修改员工信息
     * @param employeeUpdateDTO employeeUpdateDTO
     * @return OK
     */
    updateEmployeeApi(employeeUpdateDTO: EmployeeUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/updateEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateEmployeeApi(_response);
        });
    }

    protected processUpdateEmployeeApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * getEmployeeDeptList
     * @param deptId deptId
     * @return OK
     */
    getEmployeeDeptList(deptId: string): Promise<EmployeeInfoBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/{deptId}/list";
        if (deptId === undefined || deptId === null)
            throw new Error("The parameter 'deptId' must be defined.");
        url_ = url_.replace("{deptId}", encodeURIComponent("" + deptId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEmployeeDeptList(_response);
        });
    }

    protected processGetEmployeeDeptList(response: AxiosResponse): Promise<EmployeeInfoBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeInfoBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<EmployeeInfoBO[]>(<any>null);
    }

    /**
     * 查询员工详细信息
     * @param id id
     * @return OK
     */
    getEmployee(id: string): Promise<EmployeeBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: AxiosResponse): Promise<EmployeeBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? EmployeeBO.fromJS(resultData200) : new EmployeeBO();
            return result200;
        }
        return Promise.resolve<EmployeeBO>(<any>null);
    }
}

export class EmployeeExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出员工列表
     * @return OK
     */
    exportEmployees(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee-excel/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportEmployees(_response);
        });
    }

    protected processExportEmployees(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 下载导入模板
     * @return OK
     */
    exportEmployeeTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee-excel/export/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportEmployeeTemplate(_response);
        });
    }

    protected processExportEmployeeTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入员工数据
     * @param file (optional) file
     * @return OK
     */
    importEmployees(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/employee-excel/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportEmployees(_response);
        });
    }

    protected processImportEmployees(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-employee')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

/** 员工管理 */
export class Employee implements IEmployee {
    /** 职权范围 */
    authority!: string | undefined;
    /** 员工编号 */
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 权限id */
    deptId!: string | undefined;
    /** 员工邮箱 */
    email!: string | undefined;
    /** 员工入职日期 */
    hireDate!: Date | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 员工工卡号 */
    jobNumber!: string | undefined;
    /** 管理员 */
    manager!: string | undefined;
    /** 员工姓名 */
    name!: string | undefined;
    /** 员工照片 */
    photoUrl!: string | undefined;
    /** PIN码 */
    pinCode!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 员工电话 */
    tel!: string | undefined;
    /** 所属租户 */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authority = data["authority"];
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.deptId = data["deptId"];
            this.email = data["email"];
            this.hireDate = data["hireDate"] ? new Date(data["hireDate"].toString()) : <any>undefined;
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.jobNumber = data["jobNumber"];
            this.manager = data["manager"];
            this.name = data["name"];
            this.photoUrl = data["photoUrl"];
            this.pinCode = data["pinCode"];
            this.status = data["status"];
            this.tel = data["tel"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["deptId"] = this.deptId;
        data["email"] = this.email;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["jobNumber"] = this.jobNumber;
        data["manager"] = this.manager;
        data["name"] = this.name;
        data["photoUrl"] = this.photoUrl;
        data["pinCode"] = this.pinCode;
        data["status"] = this.status;
        data["tel"] = this.tel;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** 员工管理 */
export interface IEmployee {
    /** 职权范围 */
    authority: string | undefined;
    /** 员工编号 */
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 权限id */
    deptId: string | undefined;
    /** 员工邮箱 */
    email: string | undefined;
    /** 员工入职日期 */
    hireDate: Date | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 员工工卡号 */
    jobNumber: string | undefined;
    /** 管理员 */
    manager: string | undefined;
    /** 员工姓名 */
    name: string | undefined;
    /** 员工照片 */
    photoUrl: string | undefined;
    /** PIN码 */
    pinCode: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 员工电话 */
    tel: string | undefined;
    /** 所属租户 */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** 员工管理 */
export class EmployeeBO implements IEmployeeBO {
    /** 员工编号 */
    code!: string | undefined;
    /** 权限id */
    deptId!: string | undefined;
    /** 员工邮箱 */
    email!: string | undefined;
    /** 员工入职日期 */
    hireDate!: Date | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 员工工卡号 */
    jobNumber!: string | undefined;
    /** 员工姓名 */
    name!: string | undefined;
    /** 员工照片 */
    photoUrl!: string | undefined;
    /** PIN码 */
    pinCode!: string | undefined;
    /** 员工电话 */
    tel!: string | undefined;

    constructor(data?: IEmployeeBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.email = data["email"];
            this.hireDate = data["hireDate"] ? new Date(data["hireDate"].toString()) : <any>undefined;
            this.id = data["id"];
            this.jobNumber = data["jobNumber"];
            this.name = data["name"];
            this.photoUrl = data["photoUrl"];
            this.pinCode = data["pinCode"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): EmployeeBO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["email"] = this.email;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["jobNumber"] = this.jobNumber;
        data["name"] = this.name;
        data["photoUrl"] = this.photoUrl;
        data["pinCode"] = this.pinCode;
        data["tel"] = this.tel;
        return data; 
    }
}

/** 员工管理 */
export interface IEmployeeBO {
    /** 员工编号 */
    code: string | undefined;
    /** 权限id */
    deptId: string | undefined;
    /** 员工邮箱 */
    email: string | undefined;
    /** 员工入职日期 */
    hireDate: Date | undefined;
    /** 主键id */
    id: string | undefined;
    /** 员工工卡号 */
    jobNumber: string | undefined;
    /** 员工姓名 */
    name: string | undefined;
    /** 员工照片 */
    photoUrl: string | undefined;
    /** PIN码 */
    pinCode: string | undefined;
    /** 员工电话 */
    tel: string | undefined;
}

/** 员工管理 */
export class EmployeeInfoBO implements IEmployeeInfoBO {
    /** 员工编号 */
    code!: string | undefined;
    /** 权限id */
    deptId!: string | undefined;
    /** 职权域名 */
    deptName!: string | undefined;
    /** 员工邮箱 */
    email!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 员工姓名 */
    name!: string | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status!: number | undefined;
    /** 员工电话 */
    tel!: string | undefined;

    constructor(data?: IEmployeeInfoBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.deptName = data["deptName"];
            this.email = data["email"];
            this.id = data["id"];
            this.name = data["name"];
            this.status = data["status"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): EmployeeInfoBO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfoBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["deptName"] = this.deptName;
        data["email"] = this.email;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["tel"] = this.tel;
        return data; 
    }
}

/** 员工管理 */
export interface IEmployeeInfoBO {
    /** 员工编号 */
    code: string | undefined;
    /** 权限id */
    deptId: string | undefined;
    /** 职权域名 */
    deptName: string | undefined;
    /** 员工邮箱 */
    email: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 员工姓名 */
    name: string | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status: number | undefined;
    /** 员工电话 */
    tel: string | undefined;
}

export class EmployeeSearchDTO implements IEmployeeSearchDTO {
    /** 状态集合 1-启用,0-禁用 */
    statusList!: number[];

    constructor(data?: IEmployeeSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusList = [];
        }
    }

    init(data?: any) {
        if (data) {
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [] as any;
                for (let item of data["statusList"])
                    this.statusList!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data; 
    }
}

export interface IEmployeeSearchDTO {
    /** 状态集合 1-启用,0-禁用 */
    statusList: number[];
}

/** 员工管理 */
export class EmployeeSubmitDTO implements IEmployeeSubmitDTO {
    /** 员工编号 */
    code!: string;
    /** 权限id */
    deptId!: string | undefined;
    /** 员工邮箱 */
    email!: string | undefined;
    /** 员工入职日期 */
    hireDate!: Date | undefined;
    /** id */
    id!: string | undefined;
    /** 员工工卡号 */
    jobNumber!: string | undefined;
    /** 员工姓名 */
    name!: string;
    /** 员工照片 */
    photoUrl!: string | undefined;
    /** PIN码 */
    pinCode!: string | undefined;
    /** 员工电话 */
    tel!: string | undefined;

    constructor(data?: IEmployeeSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.email = data["email"];
            this.hireDate = data["hireDate"] ? new Date(data["hireDate"].toString()) : <any>undefined;
            this.id = data["id"];
            this.jobNumber = data["jobNumber"];
            this.name = data["name"];
            this.photoUrl = data["photoUrl"];
            this.pinCode = data["pinCode"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): EmployeeSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["email"] = this.email;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["jobNumber"] = this.jobNumber;
        data["name"] = this.name;
        data["photoUrl"] = this.photoUrl;
        data["pinCode"] = this.pinCode;
        data["tel"] = this.tel;
        return data; 
    }
}

/** 员工管理 */
export interface IEmployeeSubmitDTO {
    /** 员工编号 */
    code: string;
    /** 权限id */
    deptId: string | undefined;
    /** 员工邮箱 */
    email: string | undefined;
    /** 员工入职日期 */
    hireDate: Date | undefined;
    /** id */
    id: string | undefined;
    /** 员工工卡号 */
    jobNumber: string | undefined;
    /** 员工姓名 */
    name: string;
    /** 员工照片 */
    photoUrl: string | undefined;
    /** PIN码 */
    pinCode: string | undefined;
    /** 员工电话 */
    tel: string | undefined;
}

/** 员工管理 */
export class EmployeeUpdateDTO implements IEmployeeUpdateDTO {
    /** 员工编号 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 员工邮箱 */
    email!: string | undefined;
    /** 员工入职日期 */
    hireDate!: Date | undefined;
    /** id */
    id!: string;
    /** 员工工卡号 */
    jobNumber!: string | undefined;
    /** 登录账号名 - 用户名 */
    loginName!: string | undefined;
    /** 员工姓名 */
    name!: string;
    /** 员工照片 */
    photoUrl!: string | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status!: number | undefined;
    /** 员工电话 */
    tel!: string | undefined;

    constructor(data?: IEmployeeUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.email = data["email"];
            this.hireDate = data["hireDate"] ? new Date(data["hireDate"].toString()) : <any>undefined;
            this.id = data["id"];
            this.jobNumber = data["jobNumber"];
            this.loginName = data["loginName"];
            this.name = data["name"];
            this.photoUrl = data["photoUrl"];
            this.status = data["status"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): EmployeeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["email"] = this.email;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["jobNumber"] = this.jobNumber;
        data["loginName"] = this.loginName;
        data["name"] = this.name;
        data["photoUrl"] = this.photoUrl;
        data["status"] = this.status;
        data["tel"] = this.tel;
        return data; 
    }
}

/** 员工管理 */
export interface IEmployeeUpdateDTO {
    /** 员工编号 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 员工邮箱 */
    email: string | undefined;
    /** 员工入职日期 */
    hireDate: Date | undefined;
    /** id */
    id: string;
    /** 员工工卡号 */
    jobNumber: string | undefined;
    /** 登录账号名 - 用户名 */
    loginName: string | undefined;
    /** 员工姓名 */
    name: string;
    /** 员工照片 */
    photoUrl: string | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status: number | undefined;
    /** 员工电话 */
    tel: string | undefined;
}

export class EmployeeVO implements IEmployeeVO {
    /** 职权范围 */
    authority!: string | undefined;
    /** 员工编号 */
    code!: string | undefined;
    /** 权限id */
    deptId!: string | undefined;
    /** 员工邮箱 */
    email!: string | undefined;
    /** 员工入职日期 */
    hireDate!: Date | undefined;
    id!: string | undefined;
    /** 员工工卡号 */
    jobNumber!: string | undefined;
    /** 管理员 */
    manager!: string | undefined;
    /** 员工姓名 */
    name!: string | undefined;
    /** 员工照片 */
    photoUrl!: string | undefined;
    /** PIN码 */
    pinCode!: string | undefined;
    /** 员工电话 */
    tel!: string | undefined;
    /** 所属租户 */
    tenantId!: string | undefined;

    constructor(data?: IEmployeeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authority = data["authority"];
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.email = data["email"];
            this.hireDate = data["hireDate"] ? new Date(data["hireDate"].toString()) : <any>undefined;
            this.id = data["id"];
            this.jobNumber = data["jobNumber"];
            this.manager = data["manager"];
            this.name = data["name"];
            this.photoUrl = data["photoUrl"];
            this.pinCode = data["pinCode"];
            this.tel = data["tel"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): EmployeeVO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["email"] = this.email;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["jobNumber"] = this.jobNumber;
        data["manager"] = this.manager;
        data["name"] = this.name;
        data["photoUrl"] = this.photoUrl;
        data["pinCode"] = this.pinCode;
        data["tel"] = this.tel;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IEmployeeVO {
    /** 职权范围 */
    authority: string | undefined;
    /** 员工编号 */
    code: string | undefined;
    /** 权限id */
    deptId: string | undefined;
    /** 员工邮箱 */
    email: string | undefined;
    /** 员工入职日期 */
    hireDate: Date | undefined;
    id: string | undefined;
    /** 员工工卡号 */
    jobNumber: string | undefined;
    /** 管理员 */
    manager: string | undefined;
    /** 员工姓名 */
    name: string | undefined;
    /** 员工照片 */
    photoUrl: string | undefined;
    /** PIN码 */
    pinCode: string | undefined;
    /** 员工电话 */
    tel: string | undefined;
    /** 所属租户 */
    tenantId: string | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfEmployeeInfoBO implements IIPageOfEmployeeInfoBO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: EmployeeInfoBO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfEmployeeInfoBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(EmployeeInfoBO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfEmployeeInfoBO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfEmployeeInfoBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfEmployeeInfoBO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: EmployeeInfoBO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}